import Offer from "../interfaces/Offer";

export function getLatestOffers(): Promise<Offer[] | undefined> {
  return fetch('https://api.offertedifuoco.it/')
  .then(response => response.json())
  .then((offers: Offer[]) => offers)
  .catch(() => {
    return undefined;
  });
}